exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination {\n  height: 40px;\n  margin: 20px 10px;\n}\n.pagination ul {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-left: 0;\n  border-radius: 3px;\n  *zoom: 1;\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  padding: 0px;\n}\n", ""]);

// exports
